export class DisplacementStatus{
    hmy:number;
    mortPrePayment?:number;
    mortInsContractVolTerm?:number;
    lackFundHousingTerm?:number;
    phProjectDemolition?:number;
    disasterDamage?:number;                
}